import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface RichTextEditorProps {
  value: string;
  onChange: (content: string) => void;
  height?: string; // optional prop
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  height = "auto", 
}) => {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "10px" }}>
      <ReactQuill
        theme="snow"
        modules={{
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ header: [1, 2, 3, false] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["link"],
            ["clean"],
          ],
        }}
        placeholder="✍️ Write your answer here..."
        value={value}
        onChange={onChange}
        style={{
          height: height, 
          width: "100%",
          background: "#fff",
          borderRadius: "8px",
          marginBottom: height === "auto" ? "70px" : undefined,
        }}
        preserveWhitespace={true}
      />
    </div>
  );
};

export default RichTextEditor;
